import Link from 'next/link';
import { TeamListItemFragment } from '@amf/shared/types/graphql';
import { useTranslate } from '@tolgee/react';
import TeamDress from '@amf/shared/components/team/TeamDress';

interface TeamListItemProps {
  team: TeamListItemFragment;
  prefix: string;
}

export function TeamListItem({ team, prefix }: TeamListItemProps) {
  const { t } = useTranslate();
  return (
    <Link href={`${prefix}/${team.id.split('||')[0]}`}>
      <a className='TeamList__item'>
        <TeamDress dress={team} className='TeamList__dress' />
        <div className='TeamList__itemContent'>
          <h3 className='TeamList__itemTitle'>{team.name}</h3>
          {team.description && <p className='TeamList__itemDescription'>{team.description}</p>}
        </div>
        <div className='TeamList__itemType'>{t(`league.type.${team.type}`)}</div>
      </a>
    </Link>
  );
}

interface TeamListProps {
  teams: TeamListItemFragment[];
  prefixes: { team: string };
  title?: string;
}

function TeamList({ teams, prefixes, title }: TeamListProps) {
  return (
    <div className='TeamList'>
      {title && <h2>{title}</h2>}
      <div className='TeamList__content'>
        {teams.map(team => (
          <TeamListItem key={team.id} team={team} prefix={prefixes.team} />
        ))}
      </div>
    </div>
  );
}

export default TeamList;
